import { jsx as _jsx, Fragment as _Fragment } from "@emotion/react/jsx-runtime";
import { useEffect, useState } from "react";
import { useFlow } from "../context/FlowContext";
import { BoxContainer } from "../layouts/Theme";
import RegisterForm from "../partials/account/RegisterForm";
export default function AccountDetails(props) {
    const flow = useFlow();
    const [mode, setMode] = useState('accountDetails');
    useEffect(() => {
        var _a, _b;
        if ((_a = flow.currentRoute) === null || _a === void 0 ? void 0 : _a.route) {
            setMode((_b = flow.currentRoute) === null || _b === void 0 ? void 0 : _b.route);
        }
    }, [flow]);
    return (_jsx(_Fragment, { children: _jsx(BoxContainer, { children: _jsx(RegisterForm, { mode: mode, registerRequired: false }) }) }));
}
